module.exports = __webpack_public_path__ + "img/gwnu_gallery3.f716282a.jpg";